import { Guid } from '@Shared.Angular/@types/guid';

export enum SmartSearchResultType {
  SOP = 'SOP',
  FlowModel = 'FlowModel'
}

export enum SmartSearchResultSubType {
  ProcessMap = 'ProcessMap',
  ProcessMapComponent = 'ProcessMapComponent',
  Workflow = 'Workflow',
  WorkflowComponent = 'WorkflowComponent'
}

export interface ISmartSearchResult {
  id: Guid;
  name: string;
  description: string;
  reason: string;
  type: SmartSearchResultType;
  subType?: SmartSearchResultSubType;
  userCanEdit: boolean;
  hasPublicForm?: boolean;
  isDraft: boolean;
  accuracyScore?: number;
  status?: string;
}
